<marv-sub-item>
    <div class="alert_item"
        [class.unread]="this.alert.status.code === this.AlertMessageStatus.Status.UNREAD"
        (click)="this.toggleAlertMessage()"
        >
        <div class="alert_item_header">
            <ion-icon [name]="this.alert.type.icon" [class]="this.alert.type.color" />
            <div class="alert_item_title">{{this.alert.title}}</div>
            <div class="alert_item_infos">                
                <div class="alert_item_status">
                    <div class="alert_item_status_label">{{this.alert.status.name | translate}}</div>
                    <ion-icon [name]="this.alert.status.icon" />
                </div>
                <div class="alert_item_date">{{this.alert.date | marvDateToString}}</div>
            </div>
        </div>
        @if(this.alert.isOpened){
            <div class="alert_item_content">{{this.alert.body}}</div>
        }
    </div>
</marv-sub-item>